import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { i18n as i18nHandler } from 'view-design'

import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from './utils/iview'
import messages from './i18n'

import 'view-design/dist/styles/iview.css'
import 'view-design/src/styles/index.less'
import './assets/scss/main.scss'
import './assets/scss/reset.scss'
import './assets/scss/themes/dark.scss'
import './assets/scss/themes/light.scss'

Vue.use(VueI18n)
Vue.locale = () => {}

const i18n = new VueI18n({
  locale: store.state.lang,
  messages,
})

Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value),
})
i18nHandler((key, value) => i18n.t(key, value))

Vue.prototype.$t = (key, value) => i18n.t(key, value)
Vue.prototype.$Message.config({
  duration: 3,
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
